import { render, staticRenderFns } from "./bing-infobox-component.vue?vue&type=template&id=45c00993"
import script from "./bing-infobox-component.vue?vue&type=script&lang=js"
export * from "./bing-infobox-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports